export default __webpack_public_path__ + "static/media/Spinner-1s-200px.3069ae20.svg";